import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AdminOverview } from "@/components/admin/AdminOverview";
import { AdminOrders } from "@/components/admin/AdminOrders";
import { AdminJobs } from "@/components/admin/AdminJobs";
import { AdminAffiliates } from "@/components/admin/AdminAffiliates";
import { AdminPayouts } from "@/components/admin/AdminPayouts";
import { AdminModeSwitch } from "@/components/admin/AdminModeSwitch";
import { YouTubeWarningBanner } from "@/components/admin/AdminYouTube";
import { AdminCustomers, AdminProducts, AdminRemovals } from "@/components/admin/AdminMisc";
import { AdminFreeOrders } from "@/components/admin/AdminFreeOrders";

const TABS = [
  ["overview", "Overview", AdminOverview],
  ["orders", "Orders", AdminOrders],
  ["products", "Products", AdminProducts],
  ["jobs", "Jobs", AdminJobs],
  ["affiliates", "Affiliates", AdminAffiliates],
  ["payouts", "Payouts", AdminPayouts],
  ["customers", "Customers", AdminCustomers],
  ["free", "Free orders", AdminFreeOrders],
  ["removals", "Removals", AdminRemovals],
];

export default function Admin() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-8" data-testid="admin-page">
      <h1 className="text-4xl font-bold text-[#4A2A18]">Admin dashboard</h1>
      <YouTubeWarningBanner />
      <AdminModeSwitch />
      <Tabs defaultValue="overview" className="mt-8">
        <TabsList className="flex h-auto flex-wrap justify-start gap-1 bg-[#F2EBE1] p-1">
          {TABS.map(([v, l]) => (
            <TabsTrigger key={v} value={v} className="px-4 py-2 text-base data-[state=active]:bg-[#A83232] data-[state=active]:text-white" data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>
          ))}
        </TabsList>
        {TABS.map(([v, , C]) => (
          <TabsContent key={v} value={v} className="mt-6"><C /></TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
